import Vue from 'vue';
import App from '@/app/App.vue';
import router from './router';
import store from './store';

import './style/style.scss';

import 'bulmalite/lib/components/loading';
import 'bulmalite/lib/components/icon';
import 'bulmalite/lib/components/modal';
import 'bulmalite/lib/components/tabs';
import 'bulmalite/lib/components/navbar';

import VueScroll from 'vue-scrollto';
import Meta from 'vue-meta';

Vue.use(VueScroll);
Vue.use(Meta);

import * as SocialSharing from 'vue-social-sharing';
import PrismicVue from 'prismic-vue';
import { htmlSerializer, linkResolver } from '@/services/prismic';

Vue.use(PrismicVue, {
  endpoint: 'https://chromosome-6.prismic.io/api/v2',
  linkResolver,
  htmlSerializer,
});
Vue.use(SocialSharing);

import Image from '@/components/image/image';

Vue.component('image-container', Image);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
